<template>
  <div>
    <vs-sidebar position-right parent="body" default-index="1" class="sidebarx" id="createPatientDetailsDrawer" spacer :click-not-close="true"
        v-model="showDrawer">
        <div class="headerClass space-y-3">
          <p class="text-xl font-semibold px-4 pt-4">Create Patients</p>
          <vs-divider></vs-divider>
        </div>
        <div class="overflow-y-auto px-4 pt-5 pb-20 flex flex-col gap-2 h-full" >
            <vs-input
                :success="!errors.first('firstName')"
                :danger="errors.first('firstName') ? true : false"
                :danger-text="errors.first('firstName')"
                val-icon-success="done"
                val-icon-danger="error"
                v-validate="'required|max:150'"
                name="firstName"
                data-vv-as="first name"
                label="First Name"
                class="w-full"
                v-model="patientDetails.firstName" />
            <vs-input
                :success="!errors.first('LastName')"
                :danger="errors.first('LastName') ? true : false"
                :danger-text="errors.first('LastName')"
                val-icon-success="done"
                val-icon-danger="error"
                v-validate="'required|max:150'"
                name="LastName"
                data-vv-as="last name"
                label="Last Name"
                class="w-full"
                v-model="patientDetails.lastName" />
            <vs-input
                :success="!errors.first('preferredName')"
                :danger="errors.first('preferredName') ? true : false"
                :danger-text="errors.first('preferredName')"
                val-icon-success="done"
                val-icon-danger="error"
                v-validate="'max:150'"
                name="preferredName"
                data-vv-as="preferred name"
                label="Preferred Name"
                class="w-full"
                v-model="patientDetails.preferredName" />
            <div>
              <label class="vs-input--label">Clinic</label>
              <vs-select
                v-model="clinicId"
                placeholder="Select Clinic"
                autocomplete
                class="w-full"
              >
                <vs-select-item
                  :key="index"
                  :value="item._id"
                  :text="item.clinicName"
                  v-for="(item, index) in clinicsList"
                />
              </vs-select>
            </div>
            <div :class="{'input-icon-validate-success': !errors.first('dateOfBirth'), 'input-icon-validate-danger': errors.first('dateOfBirth')}">
              <label class="vs-input--label">Date of Birth</label>
              <Datepicker format="dd/MM/yyyy" :minimumView="'day'" :maximumView="'year'"
                :initialView="'year'" :disabled-dates="disabledDatesDOB" v-model="dateOfBirthModel" :input-class="{
                  'is-true vs-input--input':
                    !errors.has('dateOfBirth'),
                  'input-icon-validate-danger vs-input--input': errors.has('dateOfBirth'),
                }">
                  <template slot="afterDateInput">
                  <span v-if="!errors.has('dateOfBirth')" class="bg-color-done input-icon-validate vs-input--icon-validate">
                    <i valiconpack="material-icons" class="vs-icon notranslate icon-scale material-icons null">done</i>
                  </span>
                  <span v-if="errors.has('dateOfBirth')" class="bg-color-error input-icon-validate vs-input--icon-validate">
                    <i valiconpack="material-icons" class="vs-icon notranslate icon-scale material-icons null">error</i>
                  </span>
                </template>
                </Datepicker>
                <small class="text-danger" style="font-size: 0.75em" v-if="errors.has('dateOfBirth')">
                  {{ errors.first("dateOfBirth") }}
                </small>
            </div>

            <div class="flex w-full">
              <div class="w-full">
                <div style="margin-top: 13px">
                  <label
                    style="display: block"
                    class="vs-input--label custom-label mb-1"
                  >
                    Gender
                  </label>
                  <vs-radio
                    vs-value="male"
                    vs-name="radios1"
                    style="margin-right: 20px"
                    v-model="patientDetails.gender"
                    >Male</vs-radio
                  >
                  <vs-radio
                    vs-value="female"
                    vs-name="radios1"
                    style="margin-right: 20px"
                    v-model="patientDetails.gender"
                    >Female</vs-radio
                  >
                  <vs-radio
                    vs-value="other"
                    vs-name="radios1"
                    v-model="patientDetails.gender"
                    >Other</vs-radio
                  >
                  <span
                    v-if="errors.first('gender')"
                    style="display: block"
                    class="text-danger text-sm error-text no-margin-span"
                    >Please select one option.</span
                  >
                </div>
              </div>
            </div>
            <div>
              <small>Address</small>
              <div class="create-patient-address" id="geocoder" />
            </div>
            <vs-textarea
                :success="!errors.first('address')"
                :danger="errors.first('address') ? true : false"
                :danger-text="errors.first('address')"
                v-validate="'required'"
                readonly
                val-icon-success="done"
                val-icon-danger="error"
                data-vv-as="address"
                name="address"
                :class="'w-full' + (errors.has('address') ? ' mb-0' : '')"
                v-model="patientDetails.address" />
              <small class="text-danger mb-2" style="font-size: 0.75em" v-if="errors.has('address') && patientDetails.address != ''">
                {{ errors.first("address") }}
              </small>
            <vs-input
                :success="!errors.first('phoneNumber')"
                :danger="errors.first('phoneNumber') ? true : false"
                :danger-text="`Invalid phone number`"
                val-icon-success="done"
                val-icon-danger="error"
                v-validate="{
                  required: true,
                  regex: /^(?:\+61|0)[2-478]\d{8}$/,
                }"
                data-vv-as="phoneNumber"
                name="phoneNumber"
                label="Phone Number"
                class="w-full"
                v-model="patientDetails.contactNumber" />
            <vs-input
                :success="!errors.first('email')"
                :danger="errors.first('email') ? true : false"
                :danger-text="errors.first('email')"
                val-icon-success="done"
                val-icon-danger="error"
                v-validate="'required|email'"
                name="email"
                data-vv-as="email"
                label="Email"
                class="w-full"
                v-model="patientDetails.email" />

          <PatientDynamicList
            v-model="patientDetails.allergies"
            title="Allergies"
            field-name="allergies"
            :errors="errors"
            @add="addAllergy"
            @delete="deleteAllergies"
          />

          <PatientDynamicList
            v-model="patientDetails.regularMedications"
            title="Regular Medication"
            field-name="regularMedications"
            :errors="errors"
            @add="addRegularMedication"
            @delete="deleteRegularMedication"
          />

          <PatientDynamicList
            v-model="patientDetails.previousMedicalDiagnoses"
            title="Previous Medical Diagnosis"
            field-name="previousMedicalDiagnoses"
            :errors="errors"
            @add="addPreviousMedicalDiagnosis"
            @delete="deletePreviousMedicalDiagnosis"
          />

          <PatientHealthIdentifiers 
            :patientDetails="patientDetails"
            :errors="errors"
          />
        </div>
        <div class="p-4 flex flex-col gap-3" slot="footer">
          <vs-button @click="handleUpdatePatientDetails" :disabled="isCreatingPatient">
              Create Patient
          </vs-button>
          <vs-button type="border" class="p-2" @click.stop="closeSideDrawer">
              Cancel
          </vs-button>
        </div>
    </vs-sidebar>
  </div>
</template>
<script>
import mapboxgl from 'mapbox-gl';
import Datepicker from 'vuejs-datepicker';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import moment from 'moment';
import PatientDynamicList from './PatientFormDynamicList.vue';
import PatientHealthIdentifiers from './PatientHealthIdentifiers.vue';
import { validateMedicareNumber, validateIRN, validateIHINumber, validateMedicareExpiryDate } from '@/utils/healthTreatment';

export default {
  name: 'SideDrawerCreatePatient',
  props: {
    selectedClinic:{
      type: String,
      default: null,
    },
    createPatientDetailsDrawer: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Datepicker,
    PatientDynamicList,
    PatientHealthIdentifiers,
  },
  data() {
    return {
      accessToken: process.env.VUE_APP_MAPBOX_API_KEY,
      region: process.env.VUE_APP_REGION,
      patientDetails: {
        email: '',
        dateOfBirth: '',
        allergies: [],
        regularMedications: [],
        previousMedicalDiagnoses: [],
        address: '',
        lastName: '',
        contactNumber: '',
        firstName: '',
        preferredName: '',
        gender: '',
        medicareCardName: '',
        medicareNumber: '',
        medicareRefNumber: '',
        medicareExpiryDate: '',
        ihiNumber: '',
      },
      clinicId: null,
      isCreatingPatient: false,
      showDrawer: false,
      clinicsList: [],
      disabledDatesDOB: { from: new Date() },
    };
  },
  computed: {
    dateOfBirthModel: {
      get() {
        return this.patientDetails.dateOfBirth;
      },
      set(val) {
        // check if user is 18 years old or above
        const isUnderEighteen = moment(new Date(val)).format('YYYY-MM-DD') >
        moment().subtract(18, 'years').format('YYYY-MM-DD');

        if (isUnderEighteen) {
          this.errors.add({
            field: 'dateOfBirth',
            msg: 'You must be at least 18 years old.',
          });
          this.isCreatingPatient = true;
          return;
        }
        this.patientDetails.dateOfBirth = val;
        this.errors.remove('dateOfBirth');
        this.isCreatingPatient = false;
      },
    },
  },
  methods: {
    closeSideDrawer() {
      this.errors.items = [];
      this.patientDetails = {
        email: '',
        dateOfBirth: '',
        allergies: [],
        regularMedications: [],
        previousMedicalDiagnoses: [],
        address: '',
        lastName: '',
        contactNumber: '',
        firstName: '',
        preferredName: '',
        gender: '',
        medicareCardName: '',
        medicareNumber: '',
        medicareRefNumber: '',
        medicareExpiryDate: '',
        ihiNumber: '',
      },
      this.errors.remove('dateOfBirth');
      this.isCreatingPatient = false;
      this.$emit('closeSideDrawer');
    },
    async getClinicsList() {
      const response = await this.$store.dispatch('doctor/getUserEMRclinics',
      {organizationId: localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}OrganizationId`)}
      );
      this.clinicsList = response.data.data;
    },
    addAllergy() {
        this.patientDetails.allergies.push('');
    },
    addRegularMedication() {
        this.patientDetails.regularMedications.push('');
    },
    addPreviousMedicalDiagnosis() {
        this.patientDetails.previousMedicalDiagnoses.push('');
    },
    deletePreviousMedicalDiagnosis(index) {
        this.patientDetails.previousMedicalDiagnoses.splice(index, 1);
    },
    deleteAllergies(index) {
        this.patientDetails.allergies.splice(index, 1);
    },
    deleteRegularMedication(index) {
        this.patientDetails.regularMedications.splice(index, 1);
    },
    async handleUpdatePatientDetails() {
      let isValid = await this.$validator.validateAll(null);
      // check if user is 18 years old or above
      const isUnderEighteen = moment(new Date(this.patientDetails.dateOfBirth)).format('YYYY-MM-DD') >
          moment().subtract(18, 'years').format('YYYY-MM-DD');
      if (
        !this.patientDetails.dateOfBirth
      ) {
        isValid = false;
        this.errors.add({
          field: 'dateOfBirth',
          msg: 'Date of Birth is required',
        });
      } else if (isUnderEighteen) {
          this.errors.add({
            field: 'dateOfBirth',
            msg: 'You must be at least 18 years old.',
          });
        } else {
        this.errors.remove('dateOfBirth');
      }
      if (this.patientDetails.allergies.length === 0) {
        isValid = false;
        this.errors.add({
          field: 'allergies',
          msg: 'Allergies is required',
        });
      }
      else{
        this.errors.remove('allergies');
      }
      if (this.patientDetails.regularMedications.length === 0) {
        isValid = false;
        this.errors.add({
          field: 'regularMedications',
          msg: 'Regular Medication is required',
        });
      }
      else{
        this.errors.remove('regularMedications');
      }
      if (this.patientDetails.previousMedicalDiagnoses.length === 0) {
        isValid = false;
        this.errors.add({
          field: 'previousMedicalDiagnoses',
          msg: 'Previous Medical Diagnosis is required',
        });
      }
      else{
        this.errors.remove('previousMedicalDiagnoses');
      }

      // Medicare validation
      if (this.patientDetails.medicareNumber && this.patientDetails.medicareNumber !== '') {
        if (!validateMedicareNumber(this.patientDetails.medicareNumber)) {
          isValid = false;
          this.errors.add({
            field: 'medicareNumber',
            msg: 'Medicare Card Number must be exactly 10 digits',
          });
        } else {
          this.errors.remove('medicareNumber');
        }
      }

      if (this.patientDetails.medicareRefNumber && this.patientDetails.medicareRefNumber !== '') {
        if (!validateIRN(this.patientDetails.medicareRefNumber)) {
          isValid = false;
          this.errors.add({
            field: 'medicareRefNumber',
            msg: 'Individual Reference Number (IRN) must be a single digit from 1-9',
          });
        } else {
          this.errors.remove('medicareRefNumber');
        }
      }

      if (this.patientDetails.ihiNumber && this.patientDetails.ihiNumber !== '') {
        if (!validateIHINumber(this.patientDetails.ihiNumber)) {
          isValid = false;
          this.errors.add({
            field: 'ihiNumber',
            msg: 'IHI Number must be exactly 16 digits',
          });
        } else {
          this.errors.remove('ihiNumber');
        }
      }

      // Medicare expiry date validation
      if (this.patientDetails.medicareExpiryDate && this.patientDetails.medicareExpiryDate !== '') {
        if (!validateMedicareExpiryDate(this.patientDetails.medicareExpiryDate)) {
          isValid = false;
          this.errors.add({
            field: 'medicareExpiryDate',
            msg: 'Medicare expiry date must be in the future',
          });
        } else {
          this.errors.remove('medicareExpiryDate');
        }
      }

      this.isCreatingPatient = true;
      try {
        if (isValid) {
          const {data} = await this.$store.dispatch('patient/createPatient', {
            ...this.patientDetails,
            clinicId: this.clinicId,
          });

          this.$vs.notify({
            title: 'Patient created',
            text: 'Patient\'s details created successfully.',
            color: 'success',
          });
          this.isCreatingPatient = false;
          this.closeSideDrawer();
          this.$emit('refetchPatientDetail');

          await this.$nextTick();
          const isDoctorPath = this.$getUserType() === 'org-owner' ? '' : '/details';
          await this.$router.replace(`/${this.$getUserType()}/patients/${data.data.patientData.id}${isDoctorPath}`);
        }
        else {
          this.$vs.notify({
            title: 'Failed',
            text: 'Please fill all the required fields',
            color: 'danger',
          });
          this.isCreatingPatient = false;
        }
      } catch (error) {
        console.log(error);
        this.isCreatingPatient = false;
        this.$vs.notify({
          title: 'Failed',
          text: 'Failed to create patient. Try again!',
          color: 'danger',
        });
      }
    },
    regionType() {
      const regions = {
        US: 'us',
        AU: 'au',
        NZ: 'nz',
      };
      return regions[this.region];
    },
    initMapboxGeocoder() {
      mapboxgl.accessToken = this.accessToken;

      let geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        types: 'address',
        countries: this.regionType(),
        placeholder: this.patientDetails ? this.patientDetails.address : '',
      });

      // Ensure the element exists before adding the geocoder
      this.$nextTick(() => {
        const geocoderContainer = document.getElementById('geocoder');
        if (geocoderContainer) {
          geocoder.addTo(geocoderContainer);
        } else {
          console.error('Geocoder container not found');
        }
      });

      geocoder.on('results', (e) => {
        this.patientDetails.address = e.config.query;
      });
      geocoder.on('clear', () => {
        this.patientDetails.address = '';
      });

      geocoder.on('result', (e) => {
        this.patientDetails.address = e.result.place_name;
      });
    },
  },
  watch: {
    clinicsList: function (newVal) {
      if (newVal.length > 0 && newVal.filter(clinic => `${clinic._id}` === `${this.clinicId}`).length === 0) {
        this.clinicId = newVal[0]._id;
      }
    },
    createPatientDetailsDrawer: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.showDrawer = newVal;
      }
    },
    showDrawer: function (newVal, oldVal) {
      if(newVal !== oldVal && !newVal && this.createPatientDetailsDrawer) {
      this.closeSideDrawer();
      }
    },
    selectedClinic: function (newVal, oldVal) {
      if  (newVal !== oldVal && this.clinicsList.filter(clinic => `${clinic._id}` === `${newVal}`).length === 0) {
        this.clinicId = this.clinicsList[0]._id;
      }
      else{
        this.clinicId = newVal;
      }
    },
  },
  mounted() {
    this.initMapboxGeocoder();
  },
  created() {
    this.getClinicsList();
  },
};
</script>
<style>

.vs-sidebar--background {
  z-index: 52000 !important;
}

.sidebarEditPatientDetailsDrawer {
  .vs-sidebar-position-right {
    max-width: 350px;
  }
}

.vs-sidebar.vs-sidebar-position-right {
  z-index: 53000;
}

.sidebarx .vs-sidebar-primary {
  max-width: none;
}

@media (min-width: 768px) {
  .sidebarx .vs-sidebar-primary {
    max-width: 350px;
  }
}
.create-patient-address .mapboxgl-ctrl-geocoder{
  width: 100%!important;
}

</style>
